'use strict';

import { attachStripeButton } from "./Stripe";
import { attachPaypalButton } from "./Paypal";

const { donation_test_mode } = drupalSettings;

let donationFormData = {}; // variable to hold donation form data

let formResetTracker = {};

export default class Donation {
  constructor() {
    if (donation_test_mode) {
      console.log(`Donation form initialization in test mode.`);
    }

    initWebformTracker();

    // monthly donation block donate button
    $('body').on("click", ".paragraph--type--pricing-item .field--name-field-link", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const form = $(this).closest(".paragraph--type--pricing").find('.webform-submission-form');
      const pricingItem = $(this).closest(".paragraph--type--pricing-item");
      const resetButton = form.find(".webform-button--reset");
      const formId = getFormId(form.attr("id"));

      const modal = $(this).closest(".paragraph--type--pricing").find(".donation-form--popup .modal");

      if (donation_test_mode) {
        console.log("Resetting form", formId);
      }

      formResetTracker[formId] = {
        amount: pricingItem.data("amount"),
        frequency: 'monthly'
      };

      resetButton.click();

      modal.addClass('active');

      $(this).closest(".paragraph--type--pricing").find('.pricing-item-wrapper').hide();

      modal.find(".webform-submission-form").addClass('loading');

      modal.find('.modal__close').on('click', function (e) {
        modal.removeClass('active');
        $(this).closest(".paragraph--type--pricing").find('.pricing-item-wrapper').fadeIn();
      });
    });

    // monthly donation block donate other amount button
    $('body').on("click", ".paragraph--type--pricing .button.donate-other", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const form = $(this).closest(".paragraph--type--pricing").find('.webform-submission-form');
      const pricingItem = $(this).closest(".paragraph--type--pricing-item");
      const resetButton = form.find(".webform-button--reset");
      const formId = getFormId(form.attr("id"));

      const modal = $(this).closest(".paragraph--type--pricing").find(".donation-form--popup .modal")

      if (donation_test_mode) {
        console.log("Resetting form", formId);
      }

      formResetTracker[formId] = {
        amount: "",
        frequency: 'monthly'
      };

      resetButton.click();
      modal.addClass('active');
      $(this).closest(".paragraph--type--pricing").find('.pricing-item-wrapper').hide();
      modal.find(".webform-submission-form").addClass('loading');

      modal.find('.modal__close').on('click', function (e) {
        modal.removeClass('active');
        $(this).closest(".paragraph--type--pricing").find('.pricing-item-wrapper').fadeIn();
      });
    });
  }
}

const initWebformTracker = () => {
  const donationForms = $('.webform-submission-donate-form');

  donationForms.each(function (k, v) {
    const form = $(v);
    const formId = getFormId(form.attr("id"));
    donationFormData[formId] = {};

    let stepKey = form.find('.form-wrapper[data-webform-key]').data('webform-key');

    var selectedRadio = form.find('input[name="amount[radios]"]:checked');

    if (selectedRadio.length >= 1) {
      let wrapper = selectedRadio.closest(".js-webform-radios-other");
      amountCallout(wrapper);
    }

    form.on("change", 'input[name="amount[radios]"]', function (e) {
      let wrapper = $(this).closest(".js-webform-radios-other");
      amountCallout(wrapper);
    });

    // make next button is attached even before behaviours
    attachProxyNextButton(stepKey, form);
  });

  // track changes in the dom
  Drupal.behaviors.donationFormTracker = {
    attach: function (context) {
      const form = $(context);

      if (!form.hasClass('webform-submission-donate-form')) return;

      // track form is rest form monthly donation block
      const formId = getFormId(form.attr("id"));
      
      let step = form.find('.form-wrapper[data-webform-key]').data('webform-key');

      if (formResetTracker[formId]) {
        const { amount, frequency } = formResetTracker[formId];
        form.addClass('loading');
        formResetTracker[formId] = null;

        // preset values
        form.find(`input[value="${frequency}"]`).click();

        if (form.find(`input[name="amount[radios]"][value="${amount}"]`).length >= 1) {
          form.find(`input[name="amount[radios]"][value="${amount}"]`).click();
        } else {
          form.find(`input[name="amount[radios]"][value="_other_"]`).click();
          form.find(`input[name="amount[other]"]`).val(amount);
        }
        if (amount != '') {
          captureDonationData(step, form);
          donationFormData[formId]['monthly_donation_block'] = true;
          form.find('.webform-button--next').trigger('click');
        } else {
          donationFormData[formId]['monthly_donation_block'] = false;
          donationFormData[formId]['hide_dollar_handle'] = true;
          form.removeClass('loading');
        }
      }

      var formWrapper = form.find('.form-wrapper[data-webform-key]');

      var selectedRadio = form.find('input[name="amount[radios]"]:checked');

      if (selectedRadio.length >= 1) {
        let wrapper = selectedRadio.closest(".js-webform-radios-other");
        amountCallout(wrapper);
      }

      form.on("change", 'input[name="amount[radios]"]', function (e) {
        let wrapper = $(this).closest(".js-webform-radios-other");
        amountCallout(wrapper);
      });

      // Check if the form wrapper exists
      if (formWrapper.length > 0) {

        form.find(".webform-button--previous").hide();
        
        if(donationFormData[formId]['hide_dollar_handle']) {
          form.find("[id^='edit-amount-radios']").find(".webform-options-display-buttons-wrapper:not(:last-child)").remove();
        }

        if(!(donationFormData[formId]['monthly_donation_block'] && step == 'your_details')) {
          attachProxyPreviousButton(form);
        }

        if (step == 'payment') {
          processPaymentStep(form);
        } else {
          attachProxyNextButton(step, form);
        }

        return;
      }
    }
  };
}

const amountCallout = (wrapper) => {
  wrapper.find(".callout").remove();

  var selectedRadio = wrapper.find('input[name="amount[radios]"]:checked');
  let message = selectedRadio.next(".webform-options-display-buttons-label").find(".description").html();

  if (message) wrapper.append(`<div class='form-item callout'>${message}</div>`);
}

/**
 * Hide the next button and preprocess before it trigger next
 * This allow to capture the essential data before going to the next page
 * @param {String} step 
 */
const attachProxyNextButton = (step, donationForm) => {
  // check if the proxy next button is already attached
  if (donationForm.find(".next-proxy").length > 0) {
    return;
  }


  let nextButton = donationForm.find(".webform-button--next");
  let nextButtonProxy = $(
    "<button/>",
    {
      text: "Next",
      type: 'button',
      class: 'next-proxy'
    }
  );

  nextButton.hide();
  nextButton.after(nextButtonProxy);

  nextButtonProxy
    .on("click",
      function (e) {
        captureDonationData(step, donationForm);
        nextButton.trigger('click');
      }
    );
}

const attachProxyPreviousButton = (donationForm) => {

  // check if the proxy next button is already attached
  if (donationForm.find(".prev-proxy").length > 0) {
    return;
  }
  
  let prevButton = donationForm.find(".webform-button--previous");

  if (prevButton.length < 1) return;

  let prevButtonProxy = $("<button/>", {
    html: "<span>Go Back</span>",
    type: 'button',
    class: 'prev-proxy go-back'
  });

  prevButton.hide();
  prevButton.after(prevButtonProxy);

  prevButtonProxy
    .on("click",
      function (e) {
        prevButton.trigger('click');
      }
    );
}

/**
 * Serialize the form and save the data for given step and store it to global variable donationFormData
 * @param {*} step 
 * @param {*} form 
 */
const captureDonationData = (step, form) => {
  let serializedData = form.serializeArray();
  const formId = getFormId(form.attr("id"));
  const serializedDataObject = serializedData.reduce((obj, item) => {
    obj[item.name] = item.value;
    return obj;
  }, {});


  if (step == 'donation_details') {
    let amount = (serializedDataObject['amount[radios]'] == '_other_') ?
      serializedDataObject['amount[other]'] :
      serializedDataObject['amount[radios]'];
    const { frequency, campaign, cause } = serializedDataObject;
    donationFormData[formId][step] = {
      frequency,
      amount,
      campaign,
      cause
    }
  } else {
    donationFormData[formId][step] = serializedDataObject;
  }

  if (donation_test_mode) {
    console.log(`Capturing data for ${step}`, serializedDataObject);
  }
}

/**
 * Generate HTML for donation summary
 * @param object data  
 * @returns HTML
 */
const populateSummaryHTML = (data) => {
  const frequencyText = `$${data.donation_details.amount} ${data.donation_details.frequency == 'once' ? 'one-time' : 'monthly'}`;

  return `
    <div class='mt-medium mb-medium'>
      <div class='mb-medium text-4xl font-bold'>Review and pay</div>
      <div class='text-2xl font-bold mb-small'>Donation Details</div>
      <div class='text-xl'>
        ${frequencyText}
      </div>
      
      ${data.your_details.donation_type == 'Business' ?
      `<div class='text-xl mt-medium font-bold mb-small'>Business</div>
        <div class='mt-small'>${data.your_details.business_name}</div>` : ''} 

      <div class='flex gap-medium ${data.your_details.donation_type == 'Business' ? ' mt-small' : ' mt-medium'}'>
        <div>
          <div class='text-xl font-bold'> 
            ${data.your_details.donation_type == 'Business' ? "Contact Person" : 'Your details'} 
          </div>
          <div class='mt-small'>${data.your_details.first_name} ${data.your_details.last_name}</div>
          <div class='mt-small'>${data.your_details.email}</div>
          <div class='mt-small'>${data.your_details.phone_number}</div>
        </div>
        <div>
          <div class='text-xl font-bold mb-small'>Address</div>
          <div class='mt-small'>${data.your_details.address}</div>
          <div class='mt-small'>${data.your_details.suburb}</div>
          <div class='mt-small'>${data.your_details.state}</div>
          <div class='mt-small'>${data.your_details.postcode}</div>
          <div class='mt-small'>${data.your_details.country}</div>
        </div>
      </div>
    </div>
  `;
}

const processPaymentStep = (form) => {
  const formId = getFormId(form.attr("id"));

  let summaryHTML = populateSummaryHTML(donationFormData[formId]);
  const formData = donationFormData[formId];
  form.find("#payment_embed_container").html(summaryHTML);

  form.find(".form-actions").append(
    $("<div/>", { class: "payment-button-wrapper", id: 'payment-button' })
  );

  form.find("#donation-payment_option").html('');  // making sure there is nothing on the payment container

  attachStripeButton(form.find("#container_stripe_button")[0], formData);
  attachPaypalButton(form.find("#container_paypal_button")[0], formData);

  if (donation_test_mode) {
    console.log("Attaching payment buttons");
    console.log("Captured donation data", formData);
  }
}

function getFormId(idString) {
  const regex = /-(node|paragraph)-(\d+)-add-form/;
  const match = idString.match(regex);
  return match[2];
}